import PropTypes from 'prop-types';
// @ts-expect-error untyped module
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import DelayUntilDateActionDetail from 'automation-ui-action-features/actions/delay-until-date/DelayUntilDateActionDetail';
import DelayUntilDateActionMetadata from 'automation-ui-action-features/actions/delay-until-date/DelayUntilDateActionMetadata';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import { jsx as _jsx } from "react/jsx-runtime";
const DelayUntilDateActionHistoryCard = ({
  actionMetadata,
  flowObjectTypeId,
  actionLabel
}) => {
  return /*#__PURE__*/_jsx(LogEventRowAction, {
    title: actionLabel,
    content: /*#__PURE__*/_jsx(DelayUntilDateActionDetail, {
      actionMetadata: actionMetadata,
      flowObjectTypeId: flowObjectTypeId
    })
  });
};
DelayUntilDateActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(DelayUntilDateActionMetadata).isRequired,
  actionLabel: PropTypes.node,
  flowObjectTypeId: ObjectTypeIdType
};
export default DelayUntilDateActionHistoryCard;